declare var wp: any;

namespace TotalContest {
    import Component = TotalCore.Common.Component;

    @Component('components.totalcontest', {
        templateUrl: 'introduction-component-template',
        bindings: {}
    })
    class IntroductionComponent {

        public constructor(private $scope) {

        }
    }
}
